import { render, staticRenderFns } from "./InactiveLayout.vue?vue&type=template&id=888e23f0&"
import script from "./InactiveLayout.vue?vue&type=script&lang=js&"
export * from "./InactiveLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports